import { useCallback, useEffect, useMemo, useState } from 'react';
import { env } from '../../env';
import { ApiRequestStatus, GlobalActions } from '../../model';
import { appRoutes } from '../../routing';
import {
  finalizeOnboardingSliceActions,
  getFinalizeOnboardingThunk,
  postCreateProspect,
  updateProspectSession,
} from '../../store';
import { AZIMUT_URL } from '../../utils';
import { useAppDispatch, useAppSelector } from '../redux';

export const useFinalizeOnboardingPageLogic = (actions: GlobalActions) => {
  const dispatch = useAppDispatch();

  const getFinalizeOnboardingResponse = useAppSelector(
    (state) => state.features.finalizeOnboarding.getFinalizeOnboardingResponse
  );
  const getFinalizeOnboardingStatus: ApiRequestStatus = useAppSelector(
    (state) => state.features.finalizeOnboarding.getFinalizeOnboardingStatus
  );
  const deletePraticaStatus: ApiRequestStatus = useAppSelector(
    (state) => state.features.finalizeOnboarding.deletePraticaStatus
  );
  const createProspectStatus: ApiRequestStatus = useAppSelector(
    (state) => state.features.finalizeOnboarding.createProspectRequest.status
  );

  const [referralCode, setReferralCode] = useState('');
  const [forceClosureApp, setForceClosureApp] = useState(false);

  useEffect(() => {
    if (referralCode && referralCode !== '') {
      dispatch(finalizeOnboardingSliceActions.setReferral(referralCode));
      dispatch(getFinalizeOnboardingThunk(referralCode));
    }
  }, [dispatch, referralCode]);

  const testPassed = useMemo(
    () =>
      getFinalizeOnboardingResponse?.passAudioTranscription &&
      getFinalizeOnboardingResponse?.passFaceComparision &&
      getFinalizeOnboardingResponse?.passDocumentRecognition &&
      getFinalizeOnboardingResponse?.passDocumentValidateResult,
    [getFinalizeOnboardingResponse]
  );

  const onClick = useCallback(() => {
    if (testPassed) {
      actions.navigate(appRoutes.SetPassword, { replace: true });
    }
  }, [testPassed, actions, dispatch, referralCode]);

  useEffect(() => {
    if (
      deletePraticaStatus === 'succeeded' ||
      deletePraticaStatus === 'failed'
    ) {
      if (env.appModule === 'web') {
        window.location.href = AZIMUT_URL;
      } else {
        setForceClosureApp(true);
      }
    }
  }, [actions, deletePraticaStatus]);

  useEffect(() => {
    if (referralCode && referralCode !== '') {
      if (testPassed) {
        dispatch(postCreateProspect({ referralCode }))
          .unwrap()
          .then(() => {
            dispatch(
              updateProspectSession({
                referralCode,
                sessionState: 'completed',
              })
            );
          });
      } else {
        dispatch(
          updateProspectSession({
            referralCode,
            sessionState: 'rejected',
          })
        );
      }
    }
  }, [testPassed, referralCode]);

  return {
    isCreationOk: testPassed && createProspectStatus === 'succeeded',
    isDeletePending: deletePraticaStatus === 'loading',
    isLoading: [getFinalizeOnboardingStatus, createProspectStatus].includes(
      'loading'
    ),
    forceClosureApp,
    onClick,
    setReferralCode,
  };
};
